import { Container, GradientLine, Text } from "./FooterStyles";

const Footer = () => {
  return (
    <Container>
      <GradientLine />
      <Text>Control Code Tech © 2025</Text>
    </Container>
  );
};

export default Footer;
